import { DefaultTheme } from 'styled-components'

const andTheme: DefaultTheme = {
  breakpoints: {
    xxl: 1500,
    xl: 1250,
    lg: 950,
    md: 750,
    sm: 450,
    xs: 300
  },
  colours: {
    white: '#ffffff',
    paleGreen: '#5ac32821',
    green: '#43A813',
    red: '#FF233C',
    darkRed: '#D82036',
    burnRed: '#A40D1F',
    yellow: '#FFC800',
    black: '#000000',
    charcoal: '#323232',
    lightGrey: '#ECECEC',
    midGrey: '#757575'
  },
  boxShadow: '0px 8px 24px #00000020'
}

export { andTheme }
